import MuiButton, { type ButtonProps } from '@material-ui/core/Button';

/**
 * The portal's button. Every page imports this one so a later move to `@backstage/ui`
 * only touches this file.
 */
export type LinkButtonProps = ButtonProps & {
  href?: string;
  target?: string;
  rel?: string;
};

export function Button(props: LinkButtonProps) {
  return <MuiButton {...props} />;
}
export type { ButtonProps };
